module.exports = __webpack_public_path__ + "static/media/payment-fail.cd27e46c.svg";